/* WaveWear 카드 재입고 알림 (ww-card-waitlist.js) — 2026-09-27
 *
 * 모든 옵션이 품절인 상품 카드에만 쓰입니다 (snippets/ww-card-options.liquid).
 *   1) 평소          [NOTIFY ME WHEN AVAILABLE] 버튼만 (테두리 버튼)
 *   2) 버튼을 누르면   같은 카드 안에 이메일 칸 + [NOTIFY ME] 가 펼쳐집니다
 *   3) 제출하면       새로고침 없이 저장하고 "You're on the list" 로 바뀝니다
 *
 * 저장은 Shopify 기본 고객 폼(form 'customer')으로 합니다. 태그 waitlist, waitlist-<핸들>.
 * 스팸 방지 확인(hCaptcha)이 뜨는 경우처럼 새로고침 없이 처리할 수 없으면
 * 평범한 폼 제출로 넘깁니다. 돌아온 페이지에서는 아래 checkReturn 이 안내 문구를 띄웁니다.
 *
 * 자바스크립트가 막히면 칸을 접는 CSS 가 안 들어가서 이메일 칸이 펼쳐진 채로 나오고,
 * 평범한 폼 제출로 저장됩니다.
 * 카드마다 <script src> 가 들어가므로 __wwWl 표시로 첫 번째만 실제로 돕니다.
 */
(function () {
  if (window.__wwWl) return;
  window.__wwWl = 1;

  var OK_TEXT = "You're on the list. We'll email you when it's back.";
  var ERR_EMAIL = 'Please enter a valid email address.';
  var ERR_FAIL = 'Something went wrong. Please try again.';

  var CSS = [
    '.ww-wl__panel{display:none}',
    '.ww-wl.is-open .ww-wl__panel{display:block;margin-top:1rem}',
    /* 담기 버튼(검정 채움)과 헷갈리지 않게 테두리 버튼으로 둡니다. */
    '.ww-wl .ww-wl__open{background:transparent;color:rgb(var(--color-foreground));border-color:rgb(var(--color-foreground))}',
    '.ww-wl.is-open .ww-wl__open{margin-top:1.1rem}',
    '.ww-wl__row{display:flex;gap:.5rem}',
    /* 입력 글자 16px 이상: 아이폰이 입력칸을 누를 때 화면을 확대하지 않게 합니다. */
    '.ww-wl__input{flex:1 1 auto;min-width:0;min-height:4rem;padding:.7rem 1rem;border:1px solid rgba(var(--color-foreground),.35);border-radius:0;background:rgb(var(--color-background));color:rgb(var(--color-foreground));font-family:inherit;font-size:1.6rem;line-height:1.2}',
    '.ww-wl__input:focus{outline:2px solid rgba(var(--color-foreground),.5);outline-offset:0}',
    '.ww-wl__submit{flex:0 0 auto;min-height:4rem;padding:.7rem 1.1rem;border:1px solid rgb(var(--color-foreground));border-radius:0;background:rgb(var(--color-foreground));color:rgb(var(--color-background));font-family:inherit;font-size:1.15rem;font-weight:600;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}',
    '.ww-wl__submit[disabled]{opacity:.6;cursor:progress}',
    '.ww-wl__msg{margin:.6rem 0 0;font-size:1.2rem;line-height:1.4}',
    '.ww-wl__msg:empty{display:none}',
    '.ww-wl__msg.is-ok{color:#1E7B45;font-weight:600}',
    '.ww-wl__msg.is-err{color:#B3261E}',
    '.ww-wl__note{margin:.5rem 0 0;font-size:1.05rem;line-height:1.4;color:rgba(var(--color-foreground),.6)}',
    '.ww-wl.is-done .ww-wl__row,.ww-wl.is-done .ww-wl__note{display:none}',
    '.ww-wl-toast{position:fixed;left:50%;bottom:2.4rem;z-index:1000;transform:translateX(-50%);max-width:calc(100% - 3.2rem);padding:1.2rem 1.6rem;background:#1E7B45;color:#fff;font-size:1.3rem;line-height:1.4;box-shadow:0 4px 16px rgba(0,0,0,.18)}',
    '@media screen and (max-width:749px){',
    '.ww-wl__submit{padding:.7rem .9rem;font-size:1.05rem}',
    '}'
  ].join('');

  function injectCss() {
    if (document.getElementById('ww-wl-css')) return;
    var st = document.createElement('style');
    st.id = 'ww-wl-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  var openBox = null;
  function setOpen(box, on) {
    if (!box) return;
    box.classList.toggle('is-open', on);
    var b = box.querySelector('[data-ww-wl-open]');
    if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) {
      if (openBox && openBox !== box) setOpen(openBox, false);
      openBox = box;
      var inp = box.querySelector('.ww-wl__input');
      if (inp && !box.classList.contains('is-done')) {
        try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); }
      }
    } else if (openBox === box) {
      openBox = null;
    }
  }

  function msg(box, text, kind) {
    var m = box.querySelector('[data-ww-wl-msg]');
    if (!m) return;
    m.textContent = text;
    m.classList.toggle('is-ok', kind === 'ok');
    m.classList.toggle('is-err', kind === 'err');
  }

  function done(box) {
    box.classList.add('is-done');
    msg(box, OK_TEXT, 'ok');
    var b = box.querySelector('[data-ww-wl-open]');
    if (b) b.textContent = "You're on the list";
  }

  function toast(text) {
    var t = document.createElement('div');
    t.className = 'ww-wl-toast';
    t.setAttribute('role', 'status');
    t.textContent = text;
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 6000);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-ww-wl-open]') : null;
    if (b) {
      e.preventDefault();
      var box = b.closest('[data-ww-wl]');
      setOpen(box, !box.classList.contains('is-open'));
      return;
    }
    // 카드 밖을 누르면 접습니다 (이미 신청한 카드는 문구가 보이도록 그대로 둡니다).
    if (openBox && !openBox.contains(e.target) && !openBox.classList.contains('is-done')) {
      setOpen(openBox, false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openBox) setOpen(openBox, false);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('ww-wl__form')) return;
    var box = form.closest('[data-ww-wl]');
    if (!box) return;
    var inp = form.querySelector('.ww-wl__input');
    if (inp && !inp.checkValidity()) {
      e.preventDefault();
      msg(box, ERR_EMAIL, 'err');
      inp.focus();
      return;
    }
    if (!window.fetch || !window.FormData || !window.URLSearchParams) return; // 옛 브라우저: 평범한 제출
    e.preventDefault();
    var sub = form.querySelector('.ww-wl__submit');
    if (sub) sub.disabled = true;
    msg(box, '', '');
    fetch(form.action, {
      method: 'POST',
      // 일반 폼과 같은 방식(urlencoded)으로 보냅니다.
      body: new URLSearchParams(new FormData(form)),
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (r) {
      var u = r.url || '';
      if (u.indexOf('/challenge') > -1) {
        // 스팸 방지 확인 화면 — 새로고침 방식으로 넘깁니다.
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
      if (u.indexOf('customer_posted=true') > -1) {
        if (sub) sub.disabled = false;
        done(box);
        return;
      }
      if (sub) sub.disabled = false;
      msg(box, ERR_FAIL, 'err');
    }).catch(function () {
      HTMLFormElement.prototype.submit.call(form);
    });
  });

  // 평범한 제출로 돌아온 경우: 주소에 customer_posted=true 와 #WwWl-... 가 붙어 옵니다.
  function checkReturn() {
    var h = window.location.hash || '';
    if (h.indexOf('#WwWl-') !== 0) return;
    if ((window.location.search || '').indexOf('customer_posted=true') < 0) return;
    var form = document.getElementById(h.slice(1));
    var box = form ? form.closest('[data-ww-wl]') : null;
    if (box) { done(box); setOpen(box, true); }
    toast(OK_TEXT);
  }

  function init() {
    injectCss();
    checkReturn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();